import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { AnimationKey } from '@app/constants/payment';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [LottieComponent],
})
export class LoaderComponent {
  options: AnimationOptions = {
    path: AnimationKey.loader,
  };

  constructor(public loader: LoaderService) {}
}
